import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { DataStateChangeEventArgs, FilterSettingsModel, QueryCellInfoEventArgs } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';

import { DocumentBO, DocumentDataBO, GetDocumentBO, LovBO, UpdateDocumentBO } from './client-employee-document.model';
import { CommonApiService } from 'src/app/commonapiservice';
import { DomSanitizer } from '@angular/platform-browser';
import { ColumnChangeBO, columnWidth } from '../employee/employee.model';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-client-employee-document',
  templateUrl: './client-employee-document.component.html',
  styleUrls: ['./client-employee-document.component.scss']
})
export class ClientEmployeeDocumentComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  documentList: DocumentBO = new DocumentBO();
  @Input() DocumentRelation: DocumentDataBO;
  DocumentfilterOptions: FilterSettingsModel;
  initialPage: object;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  @ViewChild('grid') public grid: GridComponent;
  public formatOptions: object;
  public formatOption: object;
  ColumnArray_documents: columnWidth[]
  id: any;
  listId: number;
  arraycol: any = [];
  DocumentName: any = [];
  Lov: LovBO = new LovBO();
  getDocumentList: GetDocumentBO = new GetDocumentBO();
  public data: Observable<DataStateChangeEventArgs>;
  lovForm: FormGroup;
  ViewedFile:any="";
  selectedDocumentFileName: any = '';
  isFieldDisabled: Boolean = false;
  isField: boolean = false;
  clientInputChange: boolean = false;
  DocumentDataList: any = [];
  pdfsrc: any;
  UpdateDocumentBO:UpdateDocumentBO=new UpdateDocumentBO();
  DocumentNameText:string=""
  checklistLid: string;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  validStatus:any='active';
  validTill : any;
  constructor(private sanitizer: DomSanitizer, public CommonAPI: CommonApiService, public toastrService: ToastrService,public dateservice: DateService,public datepipe: DatePipe,
    public global: GlobalComponent, public formBuilder: FormBuilder) {
    this.lovForm = this.formBuilder.group({
      Name: ['', Validators.required],
      isRequired : [Boolean]
    });
    this.data = CommonAPI;
  }
  ngOnInit(): void {
   
    let JsonPage =10;
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: JsonPage,
      pageSize: JsonPage,
      pageSizes: ['10', '20', '50', '100', '250'],
    };
    this.getDocumentList.pageitem = JsonPage;
    this.DocumentDropdown();
    if (this.DocumentRelation.isDocumentVerified == 'Client') {
      this.getClientDocuments();
    }
    else if (this.DocumentRelation.isDocumentVerified == 'Employee') {
      this.getEmployeeDocuments();
    }
    this.DocumentfilterOptions = { type: 'Menu' };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy h:mm:ss a" };
    this.formatOption = { type: 'date', format: 'MM/dd/yyyy' };

    this.getpermission();
  }
  downloadFile(data) {
    let params = new URLSearchParams();
    params.append("DocumentId", data.id.toString());
    let url = "api/ClientDocument/GetBlobDownloadurl?"
    this.CommonAPI.GetFunctionwithResponseTypeText(
      params, url
    ).subscribe(
      (res) => {
        window.open(res);
      },
      (err: any) => {
        this.toastrService.error(err, "Error"), 8000;
      }
    );
  }

  setDocumentId(data) {
    this.id = data.id
  }
  deleteClientDocument() {
    let params = new URLSearchParams();
    params.append("Id", this.id.toString());
    let url = "api/ClientDocument/DeleteDocument?"
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getClientDocuments();
      this.toastrService.success(
        "Document deleted successfully!"
      );
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);

      document.getElementById("deletedocument").click()
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }
  deleteEmployeeDocument() {
    let params = new URLSearchParams();
    params.append("Id", this.id.toString());
    let url = "api/EmployeeDocument/DeleteEmployeeDocument?"
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getEmployeeDocuments();
      this.toastrService.success(
        "Document deleted successfully!"
      );
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);

      document.getElementById("deletedocument").click()
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  getClientDocuments() {
    this.getDocumentList.clientId = this.DocumentRelation.Id;
    let count = 0;
    let url = "api/ClientDocument/GetDocumentList"
    this.getDocumentList.checklistLid = this.checklistLid;
    let responseData =
    {
      result: "listcli",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.getDocumentList, responseData, "");
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DocumentDataList = data.result;
      // if (data != null && data != undefined && count == 1) {
      //   this.getColumnwidth();
      // }
      if (data.result.length > 15) {
        this.grid.height = "500";
      } else {
        this.grid.height = "auto";
      }
    },
      (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
  }
  DocumentDropdown() {
    let params = new URLSearchParams();
    if (this.DocumentRelation.isDocumentVerified == 'Client') {
      params.append("Code", "DOCNAME");
    }
    else if (this.DocumentRelation.isDocumentVerified == 'Employee') {
      params.append("Code", "EMPLOYEEDOCNAME");
    }
    let url = "api/LOV/getLovType?";
    params.append("userId", this.global.userID);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DocumentName = data;
      this.DocumentName.forEach((element) => {
        this.listId = element.listId;
      })
    })
  }
  
  clearFileInput() {
    // This will clear the file name from the input
    this.fileInput.nativeElement.value = '';
  }
  @ViewChild('fileInput') fileInput: ElementRef;
  opennewDocument() {
    this.documentList = new DocumentBO()
    this.documentList.fileString=""
    this.selectedDocumentFileName = '';
    this.clearFileInput();
  }
  onDOCFileChanged(files) {
    let val = files.item(0);
    this.documentList.fileString = files.item(0);
    this.selectedDocumentFileName = files.item(0).name;
  }
  async SaveClientDocument(documentdatas) {
    this.isField = true;
    let documentdata = JSON.parse(JSON.stringify(documentdatas))
    documentdata.clientId = (this.DocumentRelation.Id != null) ? this.DocumentRelation.Id : null;
    let basevalue: any;
    if (documentdata.fileString != null && documentdata.fileString != undefined) {
      basevalue = await this.tobase64(this.documentList.fileString);
      documentdata.fileString = basevalue;
    }
    documentdata.filepath = this.selectedDocumentFileName;
   
    if(this.documentList.validTill == null || this.documentList.validTill == ''||this.documentList.validTill == undefined){
      this.documentList.validTill = null;
      documentdata.validTill = null;
    }
    else
    documentdata.validTill = this.global.getDateTimeString(this.documentList.validTill);
    let url = "api/ClientDocument/SaveClientDocument";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(documentdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.isField = false;
      this.toastrService.success(
        "Document saved successfully!",
      );
      this.getClientDocuments();
      document.getElementById("DocumentAddopen").click();
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
    },
      (err: any) => {
        this.isField = false;
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  async SaveEmployeeDocument(documentdatas) {
    this.isFieldDisabled = true;
    let documentdata = JSON.parse(JSON.stringify(documentdatas))
    documentdata.documentNameLid = documentdata?.documentNameLid?.value != null ? documentdata?.documentNameLid?.value : null;
    documentdata.employeeId = (this.DocumentRelation.Id != null) ? (this.DocumentRelation.Id) : null;
    let basevalue: any;
    if (documentdata.fileString != null && documentdata.fileString != undefined) {
      basevalue = await this.tobase64(this.documentList.fileString);
      documentdata.fileString = basevalue;
    }
    let url = "api/EmployeeDocument/SaveEmployeeDocument";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(documentdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.isFieldDisabled = false;
      this.toastrService.success(
        "Document saved successfully!",
      );
      this.getEmployeeDocuments();
      document.getElementById("DocumentAddopen").click();
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
    },
      (err: any) => {
        this.isFieldDisabled = false;
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  clearlov() {
    this.lovForm.reset()
  }
  saveLov(listParam) {
    let val = listParam.lovName.replace(/\s/g, "");
    let url = "api/LOV/SaveLov";
    if (this.DocumentRelation.isDocumentVerified == 'Client') {
      let obj = {
        ListId: this.listId,
        Id: listParam.Id,
        lovCode: val.toUpperCase(),
        lovName: listParam.lovName,
        lovValue: null,
        orderby: 0,
        isRequired : listParam.isRequired
      }
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.DocumentDropdown();
        this.toastrService.success(
          "Document created successfully!"
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
        document.getElementById("DocumentsLovopen").click()
      },
        (err: any) => {
          this.toastrService.error(
            err,
            "error",
          );
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);

        })
    }
    else if (this.DocumentRelation.isDocumentVerified == 'Employee') {
      let obj = {
        ListId: this.listId,
        Id: listParam.Id,
        lovCode: val.toUpperCase(),
        lovName: listParam.lovName,
        lovValue: null,
        orderby: 0,

      }
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.DocumentDropdown();
        this.toastrService.success(
          "Document created successfully!"
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
        document.getElementById("DocumentsLovopen").click()
      },
        (err: any) => {
          this.toastrService.error(
            err,
            "error",
          );
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);

        })
    }
  }
  inputChangeValue() {
    this.clientInputChange = true;
  }
  clientDocumentClose() {
    // if (this.clientInputChange == true) {
    //   document.getElementById('cancelmodal').click();
    // } else {
    //   document.getElementById('DocumentAddopen').click();
    //   this.clientInputChange = false;
    // }
    document.getElementById('DocumentAddopen').click();
    this.clientInputChange = false;
  }
  goback() {
    document.getElementById('cancelmodal').click();
    document.getElementById('DocumentAddopen').click();
    this.clientInputChange = false;
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray_documents = this.arraycol[0].ClientNotes.Columns;
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    if (this.grid != undefined) {
      this.ColumnArray_documents?.forEach(element => {
        if (element.column == 'Document Name') {
          const column = this.grid.getColumnByField('documentName');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Document Title') {
          const column1 = this.grid.getColumnByField('documentTitle');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Filepath') {
          const column1 = this.grid.getColumnByField('filepath');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Attached Date') {
          const column1 = this.grid.getColumnByField('attachedDate');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Actions') {
          const column1 = this.grid.getColumnByUid('action');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'MN Choice Assessment Received') {
          const column1 = this.grid.getColumnByUid('isMNChoiceAssessment');
          column1.width = element.width;
          this.grid.refreshHeader();
        }

      });
    }
  }
  SaveColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.arraycol[0].ClientDocuments.Columns = this.ColumnArray_documents;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
  onResizeDocuments(args) {
    if (this.ColumnArray_documents != undefined && this.ColumnArray_documents != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray_documents?.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  public onActionCompleteDocuments(args) {
    this.getDocumentList.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.getDocumentList.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getDocumentList.type = args.columnType
    }
  }
  public dataStateChangeDocuments(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getDocumentList.orderColumn = state.sorted[0].name;
        this.getDocumentList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      this.getDocumentList.field = state.action.currentFilterObject.field;
      this.getDocumentList.matchCase = state.action.currentFilterObject.matchCase;
      this.getDocumentList.operator = state.action.currentFilterObject.operator;
      this.getDocumentList.value = state.action.currentFilterObject.value;
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.getDocumentList.type = "string"
        this.getDocumentList.field = "documentName";
        this.getDocumentList.operator = "contains";
        this.getDocumentList.value = "";
        this.getDocumentList.matchCase = false;

        this.getDocumentList.clientId = this.global.clientId;
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].ClientDocuments.Pagesize != state.take) {
          this.arraycol[0].ClientDocuments.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
    if (this.DocumentRelation.isDocumentVerified == 'Client') {
      this.getClientDocuments();
    }
    else if (this.DocumentRelation.isDocumentVerified == 'Employee') {
      this.getEmployeeDocuments();
    }
  }
  getEmployeeDocuments() {
    this.getDocumentList.employeeId = this.DocumentRelation.Id;
    let count = 0;
    let url = "api/EmployeeDocument/GetEmployeeDocumentList"
    let responseData =
    {
      result: "listcli",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.getDocumentList, responseData, "");
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DocumentDataList = data.result;
      
      if (data != null && data != undefined && count == 1) {
        this.getColumnwidth();
      }
      if (data.result.length > 15) {
        this.grid.height = "500";
      } else {
        this.grid.height = "auto";
      }
    },
      (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
  }

  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  getViewDocuments(list) {
    let params = new URLSearchParams();
    let url;
    this.pdfsrc = null;
    if (this.DocumentRelation.isDocumentVerified == 'Client') {
      url = "api/ClientDocument/getClientDocBase64?"
      params.append("ClientDocId", list.id.toString());
    }
    else if (this.DocumentRelation.isDocumentVerified == 'Employee') {
      url = "api/EmployeeDocument/getEmployeeDocBase64?"
      params.append("employeeDocId", list.id.toString());
    }
    this.CommonAPI.GetFunctionwithResponseTypeText(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    
     
      this.ViewedFile=list
      if (list.fileExtension == "pdf") {
        document.getElementById("openViewModal").click();
        this.pdfsrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data);
      }
      else if (list.fileExtension == "webp" || list.fileExtension == "png" || list.fileExtension == "jpeg" || list.fileExtension == "jpg") {
        document.getElementById("openViewModal").click();
        this.pdfsrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + data);
      }
      else {
        document.getElementById("openViewModal").click();
        const base64EncodedContent = data;
        const decodedContent = atob(base64EncodedContent); 
        const textBlob = new Blob([decodedContent], { type: 'text/plain' });
        this.pdfsrc = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(textBlob));
      }

    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }

  displayExcel(base64Data: string) {
    const binaryData = atob(base64Data);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const byteArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      byteArray[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    return window.URL.createObjectURL(blob);
  }
  //.................................................b64toBlob..............................................


  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  getExcelURL(): string {
    // Constructing the data URL
   
    return 'data:@file/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + this.pdfsrc;
  }
  // DownloadViewedFile()
  // {
  //   // if (this.ViewedFile != null) {
  //   //   window.open(this.ViewedFile);
  //   // }
    
  // }
  //////////////////////// Update Client Employee Document /////////////////////////////
  EditDocument(data){
    this.documentList.id=data.id;
    this.documentList.documentTitle=data.documentTitle;
    this.selectedDocumentFileName=data.filepath?.substring(data.filepath?.lastIndexOf('/') + 1);
    this.DocumentNameText=data.documentName
    this.UpdateDocumentBO.id=data.id;
    this.UpdateDocumentBO.documentTitle=data.documentTitle;
    this.UpdateDocumentBO.documentNameLid = data.documentNameLid;
    this.documentList.isMNChoiceAssessment= (data.isMNChoiceAssessment==true||data.isMNChoiceAssessment=='Yes')?true:false;
    this.documentList.validTill = this.datepipe.transform(data.validTill, "MM/dd/YYYY")
   

  }
  UpdateClientEmployeeDocTitle(){
    let url;
    this.isField=true;
    this.UpdateDocumentBO.documentTitle=this.documentList.documentTitle;
    this.UpdateDocumentBO.isMNChoiceAssessment=this.documentList.isMNChoiceAssessment;
    if(this.documentList.validTill == null || this.documentList.validTill == ''||this.documentList.validTill == undefined){
      this.documentList.validTill = null;
      this.UpdateDocumentBO.validTill = null;
    }
    else
    this.UpdateDocumentBO.validTill = this.global.getDateTimeString(this.documentList.validTill) ;
    this.UpdateDocumentBO.documentNameLid = this.UpdateDocumentBO.documentNameLid;
    if(this.DocumentRelation.isDocumentVerified== 'Client'){
       url = "api/ClientDocument/UpdateDocument";
    }
    else{
       url = "api/EmployeeDocument/UpdateEmployeeDocument";
    }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(this.UpdateDocumentBO, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.isField=false;
      this.toastrService.success(
        "Document updated successfully!",
      );
      if(this.DocumentRelation.isDocumentVerified== 'Client'){
        this.getClientDocuments();
      }else{
        this.getEmployeeDocuments();
      }
      document.getElementById("DocumentAddopen").click();
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
    },
      (err: any) => {
        this.isField=false;
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }


  newdates(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'Startdate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);

        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          this.documentList.validTill = val1;
          this.validTill = val1;
          

        }
      }
    }
    if (type == "datechanged") {
      if (name == 'Startdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.documentList.validTill = val1;
          this.validTill = val1;
       
        }
      }

    }
  }

  
statusChangeCall(val) {
  this.getDocumentList.validStatus = val;
  this.getClientDocuments();
}
Refresh(){
  this.getDocumentList.checklistLid = '';
  this.getDocumentList.validStatus = 'active';
  this.getClientDocuments();
}


  fp:any;
  getpermission() {
     let params = new URLSearchParams();
     if (this.DocumentRelation.isDocumentVerified == 'Client') {
       params.append("pagecode", "Client");
     }
     else{
       params.append("pagecode", "Employee");
     }
    
    // params.append("agencyId", this.global.agencyId);
     let url = "api/FunctionPermission/getfunctionpermissionemployee?";
     this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       if (data != null) {
         this.fp = data;
       }
       else {
         this.fp = null;
       }
     },
       (err: HttpErrorResponse) => {
         this.fp = null;
       })
   }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
